// src/components/ui/input.jsx
import React from 'react';

const Input = React.forwardRef(({ 
  className = '', 
  type = 'text',
  error = false,
  ...props 
}, ref) => {
  const baseClasses = `
    flex h-10 w-full rounded-md border border-gray-300 
    bg-white px-3 py-2 text-sm 
    placeholder:text-gray-400
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
    disabled:cursor-not-allowed disabled:opacity-50
    transition-colors
  `;

  const errorClasses = error ? 'border-red-500 focus:ring-red-500' : '';
  
  return (
    <input
      type={type}
      ref={ref}
      className={`${baseClasses} ${errorClasses} ${className}`.trim()}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export { Input };